import React from 'react';

/**
 * Non-blocking boundary for optional UI widgets.
 * Prevents a single accessory component from blanking the whole app.
 */
export default class SoftErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[Flea] SoftErrorBoundary (${this.props.name || 'widget'})`, error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
